import { styled } from 'styled-components'

export const Subtitle = styled.span`
	font-size: 0.9rem;
	opacity: 0.6;
`
